import { ServiceBase } from "services/base-service";
import type { ValidationTemplate, ValidationTemplates } from "features/languages/types/validation-templates";

class ValidationTemplatesService extends ServiceBase {
  constructor() {
    super();

    this.baseUrl = `${this.baseUrl}/ValidationTemplates`;

    this.getValidationTemplates = this.getValidationTemplates.bind(this);
    this.getValidationTemplate = this.getValidationTemplate.bind(this);
    this.deleteValidationTemplate = this.deleteValidationTemplate.bind(this);
  }

  async getValidationTemplates(abortController?: AbortController): Promise<ValidationTemplates> {
    const response = await this.sendGet("", abortController);

    return response;
  }

  async getValidationTemplate(id: number, abortController?: AbortController): Promise<ValidationTemplate> {
    const url = `/${id}`;
    const response = await this.sendGet(url, abortController);

    return response;
  }

  async saveValidationTemplate(
    validationTemplate: Omit<ValidationTemplate, "author" | "dateModified">,
    abortController?: AbortController,
  ): Promise<{ id: number }> {
    const response = await this.sendPut("", validationTemplate, abortController);

    return response;
  }

  async deleteValidationTemplate(id: string, abortController?: AbortController): Promise<string> {
    const url = `/${id}`;
    const response = await this.sendDelete(url, abortController);

    return response;
  }

  async assignValidationTemplate(
    { projectLanguageId, validationTemplateId }: { projectLanguageId: number; validationTemplateId: number | null },
    abortController?: AbortController,
  ) {
    const url = `/AssignValidationTemplate`;
    const response = await this.sendPut(url, { projectLanguageId, validationTemplateId }, abortController);

    return response;
  }
}

const validationTemplatesService = new ValidationTemplatesService();

export { validationTemplatesService };
